module.exports = __webpack_public_path__ + "img/25.f014c826.svg";